module.exports = __webpack_public_path__ + "static/media/frosty-head.8efd59d6.svg";